export type FormNotication = {
	id: string;
	properties: Record< string, unknown >;
};

export type FormNotications = FormNotication[];
